module.exports = __webpack_public_path__ + "img/green-1-diamond-open.ab9ae59b.svg";